export interface IAddressSmbExtension {
  addressId: string;
  existingSmbProduct: Record<string, number> | null;
}

export enum SmbProductMapping {
  BCONN = 'Business-Connect',
  BHSIC = 'Business-PureFibre',
  BSHUB = 'Business-wHSIA',
  BTS = 'Business-TELUS-Secure',
  BMOB = 'Business-Mobility',
  BTV = 'Business-Telus-TV',
}
